import { useInView } from 'react-intersection-observer';
import createAnimationArr from '@/src/lib/helpers/createAnimationArr';
import NextImage from '@/src/components/ui/nextImage/NextImage';
import Button from '@/src/components/ui/button/Button';
import Wrapper from '@/src/components/ui/wrapper/Wrapper';
import logo_ac from '@/public/images/collab/logo_ac.svg';
import logo_segment from '@/public/images/collab/logo_segment.svg';
import ac__front from '@/public/images/collab/ac__front.jpg';
import ac__back from '@/public/images/collab/ac__back.jpg';
import segment__back from '@/public/images/collab/segment__back.jpg';
import segment__mid from '@/public/images/collab/segment__mid.jpg';
import segment__front from '@/public/images/collab/segment__front.jpg';

import styles from './CollabSection.module.scss';

const CollabSection = () => {
  const heading = 'Noord and Beyond, Discover the Full Collection of Shopify Themes';
  const excerpt = `Take a look at the extensive Shopify theme collection with a variety of designs and feature sets to suit your style and purposes.`;

  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: `-300px 0px`,
    threshold: 0,
  });

  return (
    <section className={styles.collab}>
      <Wrapper className={styles.wrapper}>
        <div className={styles.collab__info} ref={ref}>
          <h2 className={`heading__1 ${styles.heading} ${inView && styles.animate__heading}`}>
            {createAnimationArr(heading, styles.word__wrapper, 0, 0.01)}
          </h2>
          <p className={`excerpt ${styles.excerpt} ${inView && styles.animate__excerpt}`}>
            {createAnimationArr(excerpt, styles.word__wrapper, 0.1, 0.01)}
          </p>
        </div>

        <div className={styles.collab__blocks}>
          <article className={styles.collab__block}>
            <div className={styles.section__left}>
              <div className={styles.collab__logo}>
                <NextImage
                  src={logo_ac}
                  alt="Logo Apparent Collective"
                  fill
                  sizes="(max-width: 576px) 90px, 104px"
                />
              </div>

              <div className={styles.section__info}>
                <p className={`heading__3 ${styles.collab__heading}`}>
                  Premium Shopify Themes With Broad Functionality
                </p>

                <div className={styles.buttons}>
                  <Button
                    buttonUrl="https://apparentcollective.com/"
                    ariaLabel="View Website"
                    target
                    color="primary-dark"
                    action="interactive">
                    View Website
                  </Button>
                  <Button
                    ariaLabel="View on Shopify"
                    color="secondary-light"
                    className={styles.button}
                    target
                    buttonUrl="https://themes.shopify.com/designers/apparent-collective/"
                    action="standard">
                    View on Shopify
                  </Button>
                </div>
              </div>
            </div>

            <div className={styles.collab__right}>
              <div className={styles.ac__back}>
                <NextImage
                  src={ac__back.src}
                  alt="Apparent Collictive Screen"
                  fill
                  sizes="
                            (max-width: 376px) 52.33vw,
                            (max-width: 414px) 48.62vw,
                            (max-width: 576px) 45.83vw,
                            (max-width: 1024px) 40.31vw,
                            (max-width: 1280px) 450px,
                            (max-width: 1480px) 485px,
                            (max-width: 1700px) 534px, 
                                                569px"
                />
              </div>
              <div className={styles.ac__front}>
                <NextImage
                  src={ac__front.src}
                  alt="Apparent Collictive Screen"
                  fill
                  sizes="
                    (max-width: 376px) 47.11vw,
                    (max-width: 414px) 44.2vw,
                    (max-width: 576px) 43.08vw,
                    (max-width: 1024px) 37.5vw,
                    (max-width: 1280px) 435px,
                    (max-width: 1480px) 470px,
                    (max-width: 1700px) 518px, 
                                        552px"
                />
              </div>
            </div>
          </article>

          <article className={styles.collab__block}>
            <div className={styles.section__left}>
              <div className={styles.collab__logo}>
                <NextImage
                  src={logo_segment}
                  alt="Logo Segment"
                  fill
                  sizes="(max-width: 576px) 100px, 124px"
                />
              </div>

              <div className={styles.section__info}>
                <p className={`heading__3 ${styles.collab__heading}`}>
                  High-End Shopify Themes with Extensive Feature Pack
                </p>

                <div className={styles.buttons}>
                  <Button
                    buttonUrl="https://madebysegment.com/"
                    ariaLabel="View Website"
                    target
                    color="primary-dark"
                    action="interactive">
                    View Website
                  </Button>
                  <Button
                    ariaLabel="View on Shopify"
                    color="secondary-light"
                    className={styles.button}
                    target
                    buttonUrl="https://themes.shopify.com/designers/madebysegment/"
                    action="standard">
                    View on Shopify
                  </Button>
                </div>
              </div>
            </div>

            <div className={styles.collab__right}>
              <div className={styles.segment__back}>
                <NextImage
                  src={segment__back.src}
                  alt="Segment Screen"
                  fill
                  sizes="
                            (max-width: 376px) 54.08vw,
                            (max-width: 414px) 49.51vw,
                            (max-width: 576px) 48.58vw,
                            (max-width: 1024px) 46.875vw,
                            (max-width: 1200px) 493px,
                            (max-width: 1280px) 538px, 
                            (max-width: 1700px) 605px, 
                                                665px"
                />
              </div>
              <div className={styles.segment__mid}>
                <NextImage
                  src={segment__mid.src}
                  alt="Segment Screen"
                  fill
                  sizes="
                    (max-width: 376px) 48.85vw,
                    (max-width: 414px) 45.97vw,
                    (max-width: 576px) 44vw,
                    (max-width: 1024px) 39.375vw, 
                    (max-width: 1200px) 440px,
                    (max-width: 1280px) 480px,
                    (max-width: 1700px) 540px, 
                                        594px"
                />
              </div>
              <div className={styles.segment__front}>
                <NextImage
                  src={segment__front.src}
                  alt="Segment Screen"
                  fill
                  sizes="
                    (max-width: 376px) 48.85vw,
                    (max-width: 414px) 45.97vw,
                    (max-width: 576px) 41.3vw,
                    (max-width: 1024px) 38.9vw, 
                    (max-width: 1200px) 434px,
                    (max-width: 1280px) 473px,
                    (max-width: 1700px) 533px, 
                                        586px"
                />
              </div>
            </div>
          </article>
        </div>
      </Wrapper>
    </section>
  );
};

export default CollabSection;
